module.exports = "/shifts/components/publishWarningModal-86c94c.html";